module.exports = __webpack_public_path__ + "static/media/ic_arrowUp_white.27f483aa.svg";